<template>
    <div class="contact-page container">
        <div class="contact-entry">
            <div class="card">
                <div class="faq">
                    <p class="description">لطفا پیش از ارسال ایمیل ، یا تماس تلفنی ، ابتدا پرسش های متداول را مشاهده
                        کنید.
                    </p>
                    <a class="link" @click.prevent="$router.push({name:'faq'})">سوالات متداول</a>
                </div>
                <div class="contact-form-wrap">
                    <p class="description">
                        برای پیگیری یا سوال درباره سفارش و ارسال پیام بهتر است از فرم زیر استفاده کنید.
                    </p>
                    <div class="contact-form">
                        <form @submit.prevent="">
                            <div class="fields">
                                <div class="form-group">
                                    <input id="title" class="form-control" type="text" required>
                                    <label for="title">موضوع</label>
                                </div>
                                <div class="form-group">
                                    <input id="name" class="form-control" type="text" required>
                                    <label for="name">نام و نام خانوادگی</label>
                                </div>
                                <div class="form-group">
                                    <input id="email" class="form-control" type="text" required>
                                    <label for="email">ایمیل</label>
                                </div>
                                <div class="form-group">
                                    <input id="phone" class="form-control" type="text" required>
                                    <label for="phone">تلفن تماس</label>
                                </div>
                                <div class="form-group">
                                    <textarea id="message" class="form-control" type="text" required></textarea>
                                    <label for="message">متن پیام</label>
                                </div>
                            </div>
                            <div class="uploader-wrap">
                                <div class="uploader">
                                    <p class="description">عکس یا ویدیو خود را جهت بارگذاری داخل کادر بیاندازید.</p>
                                    <p class="footnote">( حداکثر ۵ تصویر jpeg یا PNG حداکثر یک مگابایت، یک ویدیو MP4
                                        حداکثر ۵۰ مگابایت ) </p>
                                    <button class="uploader-btn">انتخاب عکس یا ویدیو</button>
                                </div>
                            </div>
                            <button class="submit-btn">ارسال پیام</button>
                        </form>

                    </div>

                </div>
            </div>

            <div class="card">
                <h6 class="section-title">تعطیلات سیزپک</h6>
                <p class="description">
                    روزهایی که به دلیل تعطیلی رسمی، سیزپک هیچ‌گونه پاسخگویی، سرویس‌دهی و خدماتی ندارد، در سال ۰۰۴۱ به
                    شرح زیر است:
                </p>
                <div class="holidays">
                    <holiday-item
                            v-for="holiday in holidays" :key="holiday"
                            :holiday="holiday"
                    />
                </div>
                <p class="description">لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ لورم ایپسوم متن ساختگی
                    با تولید سادگی نامفهوم از صنعت چاپ </p>
            </div>
            <div class="card">
                <div class="section-title">
                    اطلاعات سیزپک
                </div>
                <div class="contact-info-section">
                    <div class="contact-info-entry">
                        <div class="address" v-for="address in addresses" :key="address">
                            <p class="item-title">{{ address.title }}</p>
                            <p class="item-description">{{ address.description }}</p>
                        </div>
                    </div>
                    <div class="map">
                        <div class="aspect11">
                            <img :src="require('@/assets/images/address-map.png')" alt="">
                        </div>
                    </div>
                </div>
                <div class="contact-number-section">
                    <div class="contact-number-item">
                        <div class="item-title">
                            <i class="icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8054 12.3887C15.396 11.9624 14.9021 11.7344 14.3787 11.7344C13.8595 11.7344 13.3614 11.9581 12.9351 12.3845L11.6012 13.7141C11.4914 13.655 11.3817 13.6002 11.2761 13.5453C11.1242 13.4693 10.9807 13.3975 10.8583 13.3216C9.6088 12.528 8.47331 11.4938 7.38426 10.1557C6.85662 9.48877 6.50204 8.92736 6.24455 8.35751C6.59069 8.04092 6.91149 7.71168 7.22386 7.39509C7.34205 7.2769 7.46024 7.15448 7.57843 7.03629C8.46487 6.14985 8.46487 5.00171 7.57843 4.11527L6.42606 2.9629C6.29521 2.83204 6.16013 2.69697 6.0335 2.56189C5.78023 2.30018 5.5143 2.03003 5.23992 1.77676C4.83047 1.37153 4.34082 1.15625 3.82584 1.15625C3.31086 1.15625 2.81277 1.37153 2.39066 1.77676C2.38644 1.78098 2.38644 1.78098 2.38221 1.7852L0.947028 3.23305C0.406722 3.77336 0.0985794 4.43185 0.0310412 5.19588C-0.0702661 6.42845 0.292752 7.5766 0.571347 8.32796C1.25517 10.1726 2.27669 11.8822 3.80052 13.7141C5.64937 15.9218 7.87391 17.6651 10.415 18.8935C11.3859 19.3536 12.6818 19.8981 14.1296 19.991C14.2183 19.9952 14.3111 19.9994 14.3956 19.9994C15.3707 19.9994 16.1896 19.6491 16.8312 18.9526C16.8354 18.9441 16.8438 18.9399 16.8481 18.9315C17.0676 18.6655 17.3208 18.4249 17.5868 18.1674C17.7683 17.9944 17.954 17.8129 18.1355 17.6229C18.5534 17.1881 18.7729 16.6816 18.7729 16.1624C18.7729 15.639 18.5492 15.1367 18.1228 14.7145L15.8054 12.3887ZM17.3166 16.8336C17.3124 16.8336 17.3124 16.8378 17.3166 16.8336C17.152 17.0108 16.9831 17.1712 16.8016 17.3485C16.5272 17.6102 16.2486 17.8846 15.9869 18.1928C15.5606 18.6486 15.0583 18.8639 14.3998 18.8639C14.3365 18.8639 14.2689 18.8639 14.2056 18.8597C12.9519 18.7795 11.7869 18.2898 10.9131 17.872C8.52397 16.7154 6.42606 15.0733 4.68273 12.9923C3.24333 11.2574 2.28091 9.6534 1.64352 7.93117C1.25095 6.88011 1.10743 6.06121 1.17075 5.28874C1.21296 4.79487 1.40291 4.38542 1.75327 4.03507L3.19267 2.59566C3.39951 2.40149 3.61901 2.29596 3.83429 2.29596C4.10022 2.29596 4.3155 2.45636 4.45057 2.59144C4.45479 2.59566 4.45901 2.59988 4.46323 2.6041C4.72072 2.8447 4.96555 3.09375 5.22304 3.35968C5.35389 3.49476 5.48897 3.62984 5.62405 3.76913L6.77642 4.9215C7.22386 5.36894 7.22386 5.78262 6.77642 6.23006C6.65401 6.35247 6.53581 6.47488 6.4134 6.59307C6.05882 6.95609 5.72113 7.29378 5.3539 7.62303C5.34545 7.63147 5.33701 7.63569 5.33279 7.64414C4.96977 8.00715 5.03731 8.36173 5.11329 8.60233C5.11751 8.615 5.12173 8.62766 5.12595 8.64033C5.42565 9.36636 5.84777 10.0502 6.48938 10.8649L6.4936 10.8691C7.65864 12.3043 8.88699 13.4229 10.242 14.2798C10.415 14.3895 10.5923 14.4782 10.7612 14.5626C10.9131 14.6386 11.0567 14.7103 11.1791 14.7863C11.1959 14.7947 11.2128 14.8074 11.2297 14.8158C11.3732 14.8876 11.5083 14.9214 11.6476 14.9214C11.998 14.9214 12.2175 14.7019 12.2892 14.6301L13.7329 13.1865C13.8764 13.043 14.1043 12.8699 14.3702 12.8699C14.632 12.8699 14.8472 13.0345 14.9781 13.178C14.9823 13.1823 14.9823 13.1823 14.9865 13.1865L17.3124 15.5123C17.7472 15.9429 17.7472 16.3861 17.3166 16.8336Z" fill="black"/>
                                <path d="M10.807 4.7574C11.9129 4.94313 12.9175 5.46656 13.7195 6.26857C14.5215 7.07059 15.0407 8.07522 15.2307 9.18116C15.2771 9.45975 15.5177 9.65392 15.7921 9.65392C15.8259 9.65392 15.8554 9.6497 15.8892 9.64548C16.2016 9.59483 16.4084 9.29935 16.3577 8.98698C16.1298 7.64888 15.4966 6.42897 14.53 5.46233C13.5633 4.49569 12.3434 3.86252 11.0053 3.63458C10.693 3.58393 10.4017 3.79076 10.3468 4.09891C10.292 4.40705 10.4946 4.70675 10.807 4.7574Z" fill="black"/>
                                <path d="M19.9756 8.82242C19.6 6.61899 18.5616 4.61395 16.966 3.01836C15.3704 1.42277 13.3653 0.384369 11.1619 0.00868772C10.8538 -0.0461871 10.5625 0.16487 10.5076 0.473013C10.457 0.785377 10.6638 1.07664 10.9762 1.13151C12.9432 1.46498 14.7372 2.39785 16.1639 3.82037C17.5907 5.24712 18.5193 7.0411 18.8528 9.00815C18.8992 9.28675 19.1398 9.48092 19.4142 9.48092C19.448 9.48092 19.4775 9.4767 19.5113 9.47248C19.8195 9.42604 20.0305 9.13056 19.9756 8.82242Z" fill="black"/>
                            </svg></i>  تلفن تماس و فکس
                        </div>
                        <div class="item-number">{{ contacts.phone }}</div>
                    </div>
                    <div class="contact-number-item">
                        <div class="item-title">
                            <i class="icon"><svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.125 0.5H1.87501C0.841067 0.5 0 1.34107 0 2.37501V13.625C0 14.659 0.841067 15.5 1.87501 15.5H18.125C19.1589 15.5 20 14.659 20 13.625V2.37501C20 1.34107 19.1589 0.5 18.125 0.5ZM18.125 1.74999C18.2099 1.74999 18.2907 1.76761 18.3645 1.79838L10 9.04798L1.63542 1.79838C1.70927 1.76765 1.79005 1.74999 1.87497 1.74999H18.125ZM18.125 14.25H1.87501C1.53017 14.25 1.24999 13.9699 1.24999 13.625V3.11901L9.59045 10.3474C9.70826 10.4493 9.85413 10.5 10 10.5C10.1459 10.5 10.2917 10.4494 10.4096 10.3474L18.75 3.11901V13.625C18.75 13.9699 18.4698 14.25 18.125 14.25Z" fill="black"/>
                            </svg></i>ایمیل سازمانی
                        </div>
                        <div class="item-number">{{ contacts.email }}</div>
                    </div>
                    <div class="answering-time">پاسخگویی ۴۲ ساعته و ۷ روز هفته</div>
                </div>
                <p class="attention description">
                    توجه داشته باشید که 300061930007 ، 300061930000 و 100061930000 تنها شماره‌هایی هستند که دیجی‌کالا از طریق آن برای کاربران و مشتریان خود پیامک (اس ام اس) ارسال می‌کند. بنابراین ارسال هرگونه پیامک تحت عنوان دیجی‌کالا، با هر شماره دیگری تخلف و سوء استفاده از نام دیجی‌کالا است. در صورت دریافت چنین پیامکی، لطفاً جهت پیگیری قانونی آن را به info@digikala.com اطلاع دهید. قابل ذکر است که این شماره‌ها تنها سامانه ارسال پیامک هستند و وضعیت پردازش سفارشات مشتریان، رویدادها، خدمات و سرویس‌های ویژه دیجی‌کالا را به اطلاع کاربران می‌رسانند. لطفاً توجه داشته باشید که امکان دریافت و رسیدگی به پیام‌های شما از طریق این شماره‌ها وجود ندارد.
                </p>

            </div>

        </div>
    </div>
</template>

<script>
import HolidayItem from "@/components/Contact/HolidayItem";

export default {
    name: "ContactPage",
    components: {HolidayItem},
    data() {
        return {
            holidays: [
                {
                    day: 13,
                    month: 'فروردین',
                    description: 'روز طبیعت'
                },
                {
                    day: 13,
                    month: 'فروردین',
                    description: 'روز طبیعت'
                },
                {
                    day: 13,
                    month: 'فروردین',
                    description: 'روز طبیعت'
                },
                {
                    day: 13,
                    month: 'فروردین',
                    description: 'روز طبیعت'
                },
                {
                    day: 13,
                    month: 'فروردین',
                    description: 'روز طبیعت'
                },
                {
                    day: 13,
                    month: 'فروردین',
                    description: 'روز طبیعت'
                },
                {
                    day: 13,
                    month: 'فروردین',
                    description: 'روز طبیعت'
                },
            ],
            addresses: [
                {
                    title: 'دفتر مرکزی',
                    description: 'هران، شهرک غرب، بلوار فرحزادی، نبش سیمای ایران، مرکز خرید پلاتین طبقه '
                },
                {
                    title: 'مراکز امور مشتری',
                    description: 'تهران، شهرک غرب، بلوار فرحزادی، نبش سیمای ایران، مرکز خرید پلاتین طبقه اول، پلاک ۱۰۷ )شنبه تا جمعه ۱۰ الی ۱۸ به جز ایام تعطیل رسمی('
                },
                {
                    title: 'خدمات پس از فروش',
                    description: ' لطفاً کالا را برای بازگرداندن و ارسال آن به خدمات پس از فروش دیجی‌کالا از طریق پست، تنها به صندوق پستی 3469-15875 ارسال کنید. )شما می‌توانید از طریق بخش سفارش‌های من اقدام به بازگردانی کالا کنید( م'
                },
                {
                    title: 'تماس با گارانتی',
                    description: 'لورم ایپسوم'
                },
            ],
            contacts:
                {
                    phone: '۰۲۱-۶۶۱۳۹۹۰۰',
                    email: 'asdfgh@gmail.com'
                }

        }
    }
}
</script>

<style lang="scss" scoped>

.contact-page {

  .section-title {
    font-weight: bold;
    font-size: 15px;
    line-height: 29px;
    text-align: right;
    color: #000000;
    border-bottom: 1px solid #FF7D0E;
    display: inline-block;
    margin-bottom: 20px;
  }

  .card {
    width: 100%;
    max-width: 800px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    padding: 22px 22px 27px;
    margin: 49px auto 10px;
  }

  .description {
    font-weight: normal;
    font-size: 12px;
    line-height: 23px;
    text-align: right;
    color: #000000;
    margin-bottom: 20px;
  }

  .faq {
    display: flex;
    justify-content: space-between;
    border-bottom: 0.3px solid rgba(0, 0, 0, 0.5);
    margin-bottom: 17px;

    & > .link {
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 29px;
      color: var(--orange_color);
      margin-bottom: 20px;
    }

  }

  .contact-form {

    .fields {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-right: -10px;
      margin-left: -10px;
      margin-bottom: 20px;

      .form-group {
        flex: 1 1 300px;
        margin-right: 10px;
        margin-left: 10px;
        margin-bottom: 30px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .uploader-wrap {
      width: 100%;
    }

    .uploader {
      display: flex;
      flex-direction: column;
      border: 0.3px dashed #000000;
      box-sizing: border-box;
      padding: 10px 0 20px;
      border-radius: 5px;
      align-items: center;
      margin-bottom: 28px;

      & > .description {
        font-weight: normal;
        font-size: 10px;
        line-height: 19px;
        text-align: right;
        color: #000000;
      }

      & > .footnote {
        font-style: normal;
        font-weight: normal;
        font-size: 9px;
        line-height: 17px;
        text-align: right;
        color: rgba(0, 0, 0, 0.7);
      }

      .uploader-btn {
        border: 1px solid #FF7D0E;
        box-sizing: border-box;
        border-radius: 5px;
        background: transparent;
        font-weight: normal;
        font-size: 12px;
        line-height: 23px;
        color: #000000;
        padding: 11px 15px;
        display: inline-block;
      }
    }

    .submit-btn {
      background: #414A53;
      border-radius: 5px;
      font-weight: bold;
      font-size: 15px;
      line-height: 29px;
      text-align: right;
      color: #FFFFFF;
      padding: 9px 40px;
      border: none;
      display: block;
      margin: auto;
    }

  }

  .holidays {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .contact-info-section {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.3);

    .contact-info-entry {
      flex: 1 1 300px;
    }

    .map {
      max-width: 250px;
      width: 100%;
      text-align: center;
      margin-bottom: 20px;
    }

    .address {
      margin-bottom: 30px;

      .item-title {
        font-weight: bold;
        font-size: 18px;
        line-height: 34px;
        text-align: right;
        color: #000000;
      }

      .item-description {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 23px;
        text-align: right;
        color: #000000;
      }
    }
  }

  .contact-number-section {
    padding: 25px 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contact-number-item {
    display: flex;
    justify-content: space-between;
    max-width: 320px;
    width: 100%;
    margin-bottom: 11px;

    &.email {
      margin-bottom: 27px;
    }

  }

  .answering-time {
    font-weight: normal;
    font-size: 13px;
    line-height: 25px;
    color: #000000;
    background: rgba(196, 196, 196, 0.4);
    border-radius: 20px;
    padding: 8px 57px;
    text-align: center;
  }
  .icon {
    margin-left: 14px;
  }

  .attention {
    padding-right: 30px;
    position: relative;
    margin-top: 16px;

    &:after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 20px;
      height: 20px;
      background: url("~@/assets/images/icon/attention-icon.svg") no-repeat;
    }
  }

}


</style>